import { render, staticRenderFns } from "./CostumerSelect.vue?vue&type=template&id=059db792&scoped=true&"
import script from "./CostumerSelect.vue?vue&type=script&lang=js&"
export * from "./CostumerSelect.vue?vue&type=script&lang=js&"
import style0 from "./CostumerSelect.vue?vue&type=style&index=0&id=059db792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059db792",
  null
  
)

export default component.exports